import { gql } from 'graphql-tag'

export const VISIT_MUTATION = gql`
    mutation visit($input: VisitInput!) {
        visit(input: $input) {
            success
        }
    }
`
